import React from "react";
import styles from "./styles.css";
import MoblieImg from "./images/mobile-img.svg";

const DummyMobile = () => {
    return (
        <div styleName={"styles.dummyMobile"}>
            <img src={MoblieImg} />
        </div>
    );
};
export default DummyMobile;
